var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIconCustomersInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10C12.3012 10 14.1667 8.13452 14.1667 5.83334C14.1667 3.53215 12.3012 1.66667 10 1.66667C7.69882 1.66667 5.83334 3.53215 5.83334 5.83334C5.83334 8.13452 7.69882 10 10 10Z",
    stroke: "#A9B1C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84167 18.3333C2.84167 15.1083 6.05 12.5 10 12.5C10.8 12.5 11.575 12.6083 12.3 12.8083",
    stroke: "#A9B1C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 15C18.3333 15.625 18.1583 16.2167 17.85 16.7167C17.675 17.0167 17.45 17.2833 17.1917 17.5C16.6083 18.025 15.8417 18.3333 15 18.3333C13.7833 18.3333 12.725 17.6833 12.15 16.7167C11.8416 16.2167 11.6667 15.625 11.6667 15C11.6667 13.95 12.15 13.0083 12.9167 12.4C13.4917 11.9417 14.2167 11.6667 15 11.6667C16.8417 11.6667 18.3333 13.1583 18.3333 15Z",
    stroke: "#A9B1C7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7 15L14.525 15.825L16.3 14.1833",
    stroke: "#A9B1C7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconCustomersInactive);
export default __webpack_public_path__ + "static/media/menu_icon_customers_inactive.a161495d59bbb26682a90ea15a288cd1.svg";
export { ForwardRef as ReactComponent };